//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Character',

  data() {
    return {
      CDN: process.env.CDN,
      characterId: this.$route.params.characterId,
    };
  },

  computed: {
    ...mapState(['isMobile']),
    ...mapGetters(['imgSuffix']),
    backgroundImageSrc() {
      return `${this.CDN}/character/feature_page_character_bg_${this.characterId}${this.imgSuffix}.jpg`;
    },
  },

  validate({ params }) {
    this.characterId = params.characterId;

    return this.characterId > 0 && this.characterId < 8;
  },
};
